import { render, staticRenderFns } from "./UserTask.vue?vue&type=template&id=44cf549c&scoped=true&"
import script from "./UserTask.vue?vue&type=script&lang=js&"
export * from "./UserTask.vue?vue&type=script&lang=js&"
import style0 from "./UserTask.vue?vue&type=style&index=0&id=44cf549c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cf549c",
  null
  
)

export default component.exports